import * as tslib_1 from "tslib";
import { Vue, Component, Prop } from "vue-property-decorator";
import axios from "axios";
import { store } from "store";
import xamatron from "xamatron";
var SpecificationsView = /** @class */ (function (_super) {
    tslib_1.__extends(SpecificationsView, _super);
    function SpecificationsView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.downloading = false;
        _this.showAllParts = false;
        _this.loading = false;
        _this.warningMessage = null;
        _this.newfileUrl = "";
        _this.mainPartTypes = [
            "drum", "blade"
        ];
        _this.deviceSpecifications = null;
        return _this;
    }
    SpecificationsView.prototype.mounted = function () {
        this.getSpecifications();
    };
    SpecificationsView.prototype.downloadFile = function (e) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.downloading = true;
                xamatron.openURL(this.fileUrl);
                return [2 /*return*/];
            });
        });
    };
    Object.defineProperty(SpecificationsView.prototype, "fileUrl", {
        get: function () {
            return window.location.protocol + "//" + window.location.host + "/api/devices/projectNotificationFile?token=" + store.sessionToken + "&serialNumber=" + this.device.serial;
        },
        enumerable: true,
        configurable: true
    });
    SpecificationsView.prototype.getSpecifications = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var deviceSpecifications, err_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.device.userHasFullAccess) {
                            this.warningMessage = this.$t("deviceSpecificationsView.limitedAccess");
                            return [2 /*return*/];
                        }
                        this.loading = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, axios.get("devicesensorlog/specification", { params: { serialNumber: this.device.serial } })];
                    case 2:
                        deviceSpecifications = (_a.sent()).data;
                        this.deviceSpecifications = deviceSpecifications;
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        this.warningMessage = this.$t("deviceSpecificationsView.limitedInformationAvailable");
                        return [3 /*break*/, 4];
                    case 4:
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(SpecificationsView.prototype, "parts", {
        get: function () {
            if (!this.showAllParts)
                return this.deviceSpecifications.components.filter(function (p) { return p.itemGroup == "BL" || p.itemGroup == "MT" || p.itemGroup == "FR" && p.inPriceList == "true" && p.eanCode != ""; });
            return this.deviceSpecifications.components.filter(function (p) { return p.inPriceList == "true" && p.eanCode != ""; });
        },
        enumerable: true,
        configurable: true
    });
    tslib_1.__decorate([
        Prop({ type: Object }),
        tslib_1.__metadata("design:type", Object)
    ], SpecificationsView.prototype, "device", void 0);
    tslib_1.__decorate([
        Prop({ type: Object }),
        tslib_1.__metadata("design:type", Object)
    ], SpecificationsView.prototype, "product", void 0);
    SpecificationsView = tslib_1.__decorate([
        Component
    ], SpecificationsView);
    return SpecificationsView;
}(Vue));
export default SpecificationsView;
